/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Gray_Eagle_LandInputs */

const en_mild_gray_eagle_land = /** @type {(inputs: Mild_Gray_Eagle_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const de_mild_gray_eagle_land = /** @type {(inputs: Mild_Gray_Eagle_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgeschlossen`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Mild_Gray_Eagle_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_gray_eagle_land = /** @type {((inputs?: Mild_Gray_Eagle_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Gray_Eagle_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_gray_eagle_land(inputs)
	return de_mild_gray_eagle_land(inputs)
});